import { Box, Button, IconButton, Modal, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { AddMenuHeadingAction } from "../../../../../store/Menu/Action";
import history from "../../../../../history";
import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import {
  GetAIConfigAction,
  TestModelAction,
} from "../../../../../store/Ancillary/AIConfig/Action";
import { toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import AIDowntimePopup from "./AIDowntimePopup";

const AICongifWarningPopup = forwardRef(({ validateFor = "Resume", style, closeReq = false }, ref) => {
  const dispatch = useDispatch();
  const aiDowntimeRef = useRef();

  const { atsModuleData } = useSelector(
    (state) => state?.RoleAndAccessReducer?.ATSModuleReducer
  );
  const CoreHRAccess = atsModuleData?.find(
    (item) => item.module_name === "Core HR"
  );
  const settingsAccess = atsModuleData?.find(
    (item) => item.module_name === "Settings"
  );
  const AIDowntime = atsModuleData?.find(
    (item) => item.module_name === "AI Downtime"
  );
  const [validationFailed, setValidationFailed] = useState(false);

  const handleNavigate = () => {
    sessionStorage.setItem("selectedMenu", "General");
    dispatch(AddMenuHeadingAction({ heading: "General" }));
    history.push({
      pathname: "/settings",
      state: { tabValue: "7" },
    });
  };
  const handleClose = () => {
    setValidationFailed(false);
  };
  const validateAIConfig = () => {
    return new Promise((resolve, reject) => {
      if (AIDowntime) {
        if (aiDowntimeRef.current) {
          aiDowntimeRef.current.openPopup();
        }
        resolve({ ok: false, reason: "downtime" });
        return;
      }

      dispatch(
        GetAIConfigAction({}, (error, result) => {
          if (!error && result?.data?.statuscode === 200) {
            if (result?.data?.data?.length) {
              const selectedModel = result?.data?.data?.find(
                (el) => validateFor === "Profile" ? el?.profile_scoring_selection : validateFor === "JD" ? el?.jd_generation_selection : el?.resume_processor_selection 
              );
              if(selectedModel?.ai_type === "Meepl Base AI"){
                setValidationFailed(false);
                resolve({ ok: true, model: selectedModel });
                return;
              }
              if (selectedModel) {
                dispatch(
                  TestModelAction(
                    {
                      apiKey: selectedModel?.ai_token,
                      model: selectedModel?.ai_token_json?.name,
                      provider: selectedModel?.ai_token_json?.provider,
                    },
                    (error, result) => {
                      if (!error && result?.data?.statuscode === 200) {
                         setValidationFailed(false);
                         resolve({ ok: true, model: selectedModel });
                         return;
                      } else {
                        setValidationFailed(true);
                        resolve({ ok: false, reason: "no_model" });
                        return;
                      }
                    }
                  )
                );
              } else {
                setValidationFailed(true);
                resolve({ ok: false, reason: "no_model" });
                return;
              }
            }
          } else {
              setValidationFailed(true);
              resolve({ ok: false, error: error || result });
              toast.error("Something went wrong!");
              return;
          }
        })
      );

    })
  }
  useImperativeHandle(ref, () => ({
    validateAIConfig,
  }));


  return (
    <>
      <Modal
        open={validationFailed}
        disablePortal
        hideBackdrop
        disableEscapeKeyDown
        onClose={() => {}}
        sx={{
          position: "absolute",
          inset: style?.inset ? style?.inset : 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backdropFilter: "blur(2px)",
          zIndex: 10,
        }}
      >
        <Box
          sx={{
            p: 3,
            borderRadius: 2,
            backgroundColor: "#fff",
            boxShadow: 3,
            textAlign: "center",
            maxWidth: 400,
            mx: "auto",
            position: "relative"
          }}
        >
         {closeReq && <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
              "&:hover": { color: "black" },
            }}
          >
            <CloseIcon />
          </IconButton>}
          <Typography variant="h6" color="error" sx={{ mb: 2 }}>
            ⚠️ AI Model Configuration Missing
          </Typography>
          <Typography sx={{ mb: 2 }}>
            It seems your AI model settings are not configured or unavailable.{" "}
            {!(CoreHRAccess && settingsAccess) &&
              "Please contact your administrator for assistance."}
          </Typography>
          {CoreHRAccess && settingsAccess && (
            <Button
              variant="contained"
              color="primary"
              onClick={handleNavigate}
              sx={{
                textTransform: "none",
                px: 3,
                borderRadius: 2,
              }}
            >
              Go to Settings
            </Button>
          )}
        </Box>
      </Modal>

      <AIDowntimePopup ref={aiDowntimeRef} style={style} closeReq={closeReq} />
    </>
  );
});

export default AICongifWarningPopup;
